import { Country } from "./Country";
import { Countries } from "./Countries";

export class CountryOperation
{
    private static simplify(input: string): string
    {
        if (!input)
            input = "";
        let arr = [" ", ".", "/", "'", "\"", "?", "!", "-", "+", "_", '\$', "@", "%", " of ", " the ", " a ", " an "];
        arr.map(pattern => input = input.split(pattern).join(""));
        input = input.split("é").join("e");
        return input.trim().toLowerCase();
    }
    static find(input: string): Country | null
    {
        if (!input)
            input = "";
        input = this.simplify(input);
        if (input)
            for (let country of Countries.getAll())
            {
                let values = [country.iso2, country.iso3, country.name];
                if (input.startsWith(country.code))
                    return country;
                if (country.other)
                    for (let i = 0; i < country.other.length; i++)
                        values.push(country.other[i]);
                for (let i = 0; i < values.length; i++)
                    if (this.simplify(values[i]) === input)
                        return country;
            }
        return null;
    }
    static findPhone(input: string): Country[]
    {
        if (!input)
            input = "";
        input = this.simplify(input);
        let ans = [];
        let max = 0;
        if (input)
            for (let country of Countries.getAll())
                if (input.startsWith(country.code))
                {
                    ans.push(country);
                    max = Math.max(country.code.length, max);
                }
        let res = [];
        for (let i = 0; i < ans.length; i++)
        {
            if (ans[i].code.length == max)
                res.push(ans[i]);
        }
        return res;
    }
    static isPhoneFromCountry(input: string, country: Country | string | null)
    {
        if (country instanceof String)
            country = this.find(country as string);
        let countries = this.findPhone(input);
        if (country)
            for (let i = 0; i < countries.length; i++)
                if (this.areEqual([countries[i], country]))
                    return true;
        return false;
    }
    static areEqual(countries: (Country | string)[]): boolean
    {
        countries = countries.map(country =>
        {
            let c: Country | null = null;
            if (country instanceof Country)
                c = country;
            else
                c = this.find(country as string);
            if (c)
                return c.name;
            throw new Error("Couldn't find country: " + country);
        });
        countries = countries.filter(v => v);
        countries = countries.filter((v, i, a) => a.indexOf(v) === i);
        return countries.length === 1;
    }
    static getCoeff(code: string, amount: number, times: number = 1): number
    {
        if (!times)
            times = 1;
        let country: Country | null = this.find(code);
        let ans: number = country?.coeff ?? 0;
        if (isNaN(ans))
            ans = 0.1;
        ans += Math.min(Math.max(1 - ans, 0), 1) * (times - 1) / times;
        ans = Math.min(Math.max(ans, 0), 1);
        if (amount)
            ans = amount * ans;
        return ans;
    }
}